// Scored & Conceded — goals scored vs conceded, both teams (Phase 3 → M2 wave 4).
//
// Thin wrapper over the shared <StatPairBars> primitive: resolve the fixture's
// two teams + the shaped view, then delegate. Data now comes from app-api via
// `useWidgetData` (was the `getScoredConcededData` legacyData getter); the pure
// shaper + the delegated DOM are unchanged. Fixture-first; timeline + rate from
// the bridge context. Controls stay out of the query key — toggles reshape the
// already-fetched payload client-side, no refetch.

import { shapeScoredConceded } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import StatPairBars from "./StatPairBars.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface ScoredConcededProps {
  fixture: string;
  /** Timeline toggle: "5" | "10" | "Season"; defaults to "5". */
  timeline?: string | null;
  /** Rate toggle: "Per Game" | "Total"; defaults to "Per Game". */
  rate?: string | null;
}

export default function ScoredConceded({
  fixture,
  timeline,
  rate,
}: ScoredConcededProps) {
  const parts = (fixture || "Arsenal v Everton").split(" v ");
  const home = (parts[0] ?? "").trim();
  const away = (parts[1] ?? "").trim();
  const { data, isPending, isError, refetch } = useWidgetData(
    "scored-conceded",
    useFixtureKey(fixture)
  );

  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const view = shapeScoredConceded(
    data ?? {},
    home,
    away,
    timeline || "5",
    rate === "Total"
  );

  if (!view) {
    return (
      <div className="data-wrapper top-align">
        <div className="module-empty">No data</div>
      </div>
    );
  }
  return <StatPairBars fixture={fixture} {...view} />;
}
